import {hasValue} from '@famly/stat_ts-utils_has-value';

import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type HealthDetailsResponse} from './health-details-query-data';

export function healthDetailsTypePatcher(data: HealthDetailsResponse): RestTypeWithTypename<HealthDetailsResponse> {
    if (!hasValue(data)) {
        return data;
    }

    return {
        __typename: 'HealthDetailsData',
        ...data,
        doctor: {
            __typename: 'Doctor',
            ...data.doctor,
        },
    };
}
